import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/UpgradePrompt.css';

function UpgradePrompt({ feature, onClose, isOpen = true }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const featureInfo = {
    test_romantic: {
      emoji: '❤️',
      title: 'تست همسر/نامزد',
      description: 'ببین عشق زندگیت چقدر تو رو می‌شناسه',
      benefits: ['سؤالات اختصاصی عاشقانه', 'تحلیل رابطه', 'نتایج خصوصی']
    },
    test_deep: {
      emoji: '🚀',
      title: 'تست عمیق (۳۰ سؤال)',
      description: 'شناخت دقیق‌تر با ۳۰ سؤال',
      benefits: ['۲۰ سؤال بیشتر', 'تحلیل کامل‌تر', 'نتایج دقیق‌تر']
    },
    test_limit: {
      emoji: '🎯',
      title: 'تست‌هات پر شد!',
      description: 'شما ۳ تست فعال دارید (محدودیت رایگان)',
      benefits: [
        'تست‌های نامحدود',
        'دسته همسر/نامزد',
        'تست عمیق ۳۰ سؤالی',
        'تست سفارشی',
        'گزارش پیشرفته',
        'استوری اینستاگرام'
      ]
    },
    advanced_analytics: {
      emoji: '📊',
      title: 'آمار پیشرفته',
      description: 'تحلیل کامل نتایج',
      benefits: ['نمودارها و چارت‌ها', 'مقایسه با دیگران', 'دانلود گزارش PDF']
    }
  };

  const info = featureInfo[feature] || featureInfo.test_deep;

  return (
    <div className="upgrade-overlay" onClick={onClose}>
      <div className="upgrade-modal" onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="upgrade-title">
        <button className="upgrade-close" onClick={onClose} type="button" aria-label="بستن">×</button>

        <div className="upgrade-modal-content">
          <div className="upgrade-icon">{info.emoji}</div>
          <h2 className="upgrade-title" id="upgrade-title">{info.title}</h2>
          <p className="upgrade-description">{info.description}</p>

          <div className="upgrade-benefits">
            <h3>با پریمیوم چه چیزی می‌گیری؟</h3>
            <div className="upgrade-benefits-list">
              {info.benefits.map((benefit) => (
                <div key={benefit} className="benefit-item">
                  <span className="benefit-check">✓</span>
                  <span>{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="upgrade-price">
            <div className="price-badge">
              <span className="price-amount">۴۹,۰۰۰ تومان</span>
              <span className="price-period">/ماهانه</span>
            </div>
            <p className="price-note">یا فقط ۳۷ هزار تومان در ماه با پلن سالانه</p>
          </div>
        </div>

        <div className="upgrade-actions">
          <button
            className="btn-upgrade-now"
            onClick={() => {
              navigate('/premium');
              onClose();
            }}
            type="button"
          >
            <span aria-hidden="true">✦</span>
            مشاهدهٔ پلن‌های پریمیوم
          </button>
          <button className="btn-maybe-later" onClick={onClose} type="button">
            فعلاً نه، ادامه می‌دهم
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpgradePrompt;
